import React, { useCallback, type FC } from 'react';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import KnowledgeHubLoadingError from '@atlassian/jira-servicedesk-knowledge-hub/src/view/knowledge-hub-loading-error/index.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { PACKAGE_NAME } from '../../constants.tsx';
import { TEAM_NAME } from '../../common/constants.tsx';
import type { AllArticleTableProps } from './types.tsx';
import { ArticleTable } from './view.tsx';

export const KnowledgeBaseHubArticlesTable: FC<AllArticleTableProps> = (props) => {
	const renderer = useCallback(() => {
		return <KnowledgeHubLoadingError projectKey={props.projectId} enableHeader={false} />;
	}, [props.projectId]);

	const onError = () => {
		fireErrorAnalytics({
			meta: {
				id: 'kbHubCrossSiteArticlesTableQuery',
				packageName: PACKAGE_NAME,
				teamName: TEAM_NAME,
			},
		});
	};

	return (
		<ErrorBoundary
			id="knowledge-hub-cross-site-articles-table"
			packageName="@atlassian/jira-servicedesk-knowledge-hub"
			render={renderer}
			onError={onError}
		>
			<Placeholder name="knowledge-hub-cross-site-articles-table" fallback={<Spinner />}>
				<ArticleTable {...props} />
			</Placeholder>
		</ErrorBoundary>
	);
};
